import React from 'react';

export default function Snackbar({ message, open, onClose, type = 'error' }) {
  if (!open) return null;
  const bg = type === 'success' ? '#22c55e' : type === 'info' ? '#3b82f6' : '#ef4444';
  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: bg,
        color: 'white',
        padding: '12px 20px',
        borderRadius: 8,
        zIndex: 3000,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
        maxWidth: '90%',
      }}
    >
      <span>{message}</span>
      <button
        type="button"
        onClick={onClose}
        style={{
          border: 'none',
          background: 'transparent',
          color: 'white',
          fontSize: 18,
          cursor: 'pointer',
        }}
        aria-label="Close"
      >
        &times;
      </button>
    </div>
  );
}
